//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { isVideoDocument } from './FileUtils.js'

export default {
  name: 'FilePreview',
  props: {
    file: {
      type: [Object, File],
      required: true
    },
    hasViewer: {
      type: Boolean,
      default: false
    },
    showBtnRemove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerStyle: function () {
      if (this.file.uploadError) {
        return 'background-color: red;'
      } else if (this.file.selected) {
        return 'background-color: #1E90FF;'
      }
      return ''
    },
    showBtnRemoveLocal: function () {
      return (this.showBtnRemove && (!this.file.props || !this.file.props.readonly)) || this.file.isToUpload
    },
    isVideoDocument: function () {
      return this.file.document != null && isVideoDocument(this.file.document) || this.file.file != null && this.file.file.type.startsWith('video/')
    },
    icon: function () {
      if (this.file.type === 'folder') {
        return 'mdi-folder-outline'
      } else if (this.isVideoDocument) {
        return 'mdi-video'
      }
      return 'mdi-file'
    }
  },
  methods: {
    onClick: function (event) {
      this.$emit('click', event)
    },
    onRemove: function (event) {
      this.$emit('delete', event)
    }
  }
}
